import { render, staticRenderFns } from "./Establishment.vue?vue&type=template&id=21dbee04&scoped=true&lang=html&"
import script from "./Establishment.vue?vue&type=script&lang=js&"
export * from "./Establishment.vue?vue&type=script&lang=js&"
import style0 from "./Establishment.vue?vue&type=style&index=0&id=21dbee04&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21dbee04",
  null
  
)

component.options.__file = "Establishment.vue"
export default component.exports